import { render, staticRenderFns } from "./importButton.vue?vue&type=template&id=07a904ee&scoped=true&"
import script from "./importButton.vue?vue&type=script&lang=js&"
export * from "./importButton.vue?vue&type=script&lang=js&"
import style0 from "./importButton.vue?vue&type=style&index=0&id=07a904ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a904ee",
  null
  
)

export default component.exports